import { useMutation } from 'react-query';
import { useSnackbar } from 'notistack';

import { axios } from 'lib';

const updateCompanyById = (companyId, data) =>
  axios.put(`/api/companies/${companyId}`, JSON.stringify(data));

export const useUpdateCompanyById = (companyId, refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (companyData) => updateCompanyById(companyId, companyData),
    onSuccess: () => {
      enqueueSnackbar('Company was successfully updated', { variant: 'success' });
      refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
